import { Link } from '@reach/router';
import * as React from 'react';
import { buttonGuideValue } from '../../../common/helpers/carousel';
import { trackUKPixelEvent, UK_PIXEL_EVENTS } from '../../../services/UKMarketingPixels.service';
import { AspectRatioImage } from '../../aspect-ratio-image/AspectRatioImage';
import { CarouselItemTitleTwo } from '../carousel-item-title-two/CarouselItemTitleTwo';
import { CarouselItemTwoProps } from './CarouselItemTwo.props';
import { StyledCarouselItemImageTwo, StyledCarouselItemTwo } from './CarouselItemTwo.styles';

export const CarouselItemTwo = ({
  handleMouseDown,
  handleMouseUp,
  handleSliderClickEvent,
  imageRatio,
  lazyLoad,
  node,
}: CarouselItemTwoProps) => {
  const { image, title, url } = node;
  const imageWithDefaults = {
    src: image.src || '/assets/images/keyart/default-wb.jpg',
    alt: image.alt || title,
  };
  const onMoviePageClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    handleSliderClickEvent(event);
    trackUKPixelEvent(UK_PIXEL_EVENTS.MOVIE_PAGE_VIEW, { destinationUrl: url });
  };

  return (
    <StyledCarouselItemTwo>
      <StyledCarouselItemImageTwo>
        <Link
          aria-hidden='true'
          className='slide-link'
          data-carousel={buttonGuideValue}
          key={url}
          onClick={onMoviePageClick}
          onMouseDown={handleMouseDown}
          onMouseUp={handleMouseUp}
          tabIndex={-1}
          to={url}
        >
          <AspectRatioImage image={imageWithDefaults} lazyLoad={lazyLoad} ratio={imageRatio || 1.5} />
        </Link>
      </StyledCarouselItemImageTwo>
      {title && <CarouselItemTitleTwo marketingMessage={node.marketingMessage} />}
    </StyledCarouselItemTwo>
  );
};
